import './App.css';
import Cards from './components/cards';

function App() {
  return (
  <>
   <div className="header bg-gray-800 h-16"></div>
   <Cards/>
  </> 
  );
}

export default App;
